import { Module } from "./modules";
import { StateManager } from "./stateManager";

// moduleRegistry.ts
export type RegisteredModule = {
  instance: ReturnType<Module>;
  name: string;
};

class ModuleRegistry {
  private modules: Map<string, RegisteredModule> = new Map();

  register(name: string, moduleInstance: ReturnType<Module>): void {
    this.modules.set(name, { instance: moduleInstance, name });
  }

  get(name: string): RegisteredModule | undefined {
    return this.modules.get(name);
  }

  getState<T extends Record<string, any>>(name: string): StateManager<T> | undefined {
    const module = this.modules.get(name);
    return module ? (module.instance.state as StateManager<T>) : undefined;
  }
}

export const moduleRegistry = new ModuleRegistry();
